<template>
  <div class="page_content">

    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <div class="module_icon ico-club"></div>
        <label class="head_txt module_type_name">{{ club.title }}</label>
      </div>
      <div class="col-5 float-right px-0">
        <div class="btn-container">
          <button @click="goToEditPage" class="btn" disabled aria-label="Edit">Edit</button>
        </div>
      </div>
    </div>

    <div class="row column-2">
      <div class="thumbnail_panel">
        <div class="thumbnail_container d-flex" tabindex="0">
          <div class="default">
            <div class="thumbnail">
              <div class="thumbnail_icon ico-club"></div>
            </div>
          </div>
        </div>
        <div class="content-row">
          <label class="heading" tabindex="0">Folder</label>
          <div class="result-value" tabindex="0">{{ clubLibraryName }}</div>
        </div>
        <div class="content-row" v-if="club.ownerName">
          <label class="heading" tabindex="0">Created By</label>
          <div class="result-value" tabindex="0">{{ club.ownerName }}</div>
        </div>
      </div>
      <div class="page-section">
        <div class="page_section_row" v-if="club.description">
          <div class="heading"><label tabindex="0">Club Description</label></div>
          <div class="page_content_block">
            <div v-html="club.description" tabindex="0"></div>
          </div>
          <a href="javascript:void(0)" class="more-btn more-desc float-right mt-1" @click="showAll" aria-label="read more">more</a>
          <b-modal id="clubDesc" class="custom_modal course_description" size="lg" centered hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="popup-heading">Club Description</div>
              <button class="btn_close" aria-label="close" @click="closeshowAll">
              <span class="ic-close"></span>
              </button>
            </div>
            <div class="catalog-desc-content" v-html="club.description"></div>
          </b-modal>
        </div>
        <!-- skills -->
        <div class="page_section_row" v-if="skills && skills.length > 0">
          <div class="heading"><label for="clubSkillTags">Skills</label></div>
          <div id="clubSkillTags" class="page_content_block">
            <div class="tag-section">
              <div class="tag-container">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="tags-row tags_container">
                  <span class="tag" v-for="tag in skills" :title="tag.name" :aria-label="tag.name">
                    <span class="tag_name competency_tag ace_sec_txt"> {{ tag.name }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- tags -->
        <div class="page_section_row" v-if="tags && tags.length > 0">
          <div class="heading"><label for="clubTags">Tags</label></div>
          <div id="clubTags" class="page_content_block">
            <div class="tag-section">
              <div class="tag-container">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="tags-row tags_container">
                  <span class="tag" v-for="tag in tags" :title="tag.name" :aria-label="tag.name">
                    <span class="tag_name instructional_tag ace_sec_txt"> {{ tag.name }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page_section_row" v-if="hasAtLeastOneLink">
          <div class="heading"><label tabindex="0">UsefulLinks</label></div>
          <div class="page_content_block">
            <div>
              <a v-if="club.url" :href="club.url" >Website</a> <span v-if="club.url">|</span>
              <a v-if="club.twitter_url" :href="club.twitter_url">Twitter</a> <span v-if="club.twitter_url">|</span>
              <a v-if="club.facebook_url" :href="club.facebook_url">Facebook</a>
            </div>
          </div>
        </div>
        <div class="page_section_row" v-if="club.phone_number">
          <div class="heading"><label tabindex="0">Phone</label></div>
          <div class="page_content_block">
            <div tabindex="0">{{ club.phone_number }}</div>
          </div>
        </div>
        <div class="page_section_row" v-if="club.address">
          <div class="heading"><label tabindex="0">Address</label></div>
          <div class="page_content_block">
            <div tabindex="0">{{ club.address }}</div>
          </div>
        </div>
        <div class="page_section_row" v-if="club.primary_contact_name">
          <div class="heading"><label tabindex="0">Primary Contact Name</label></div>
          <div class="page_content_block">
            <div tabindex="0">{{ club.primary_contact_name }}</div>
          </div>
        </div>
        <div class="page_section_row" v-if="club.primary_contact_email">
          <div class="heading"><label tabindex="0">Primary Contact Email</label></div>
          <div class="page_content_block">
            <div tabindex="0">{{ club.primary_contact_email }}</div>
          </div>
        </div>
        <div class="page_section_row" v-if="club.primary_contact_phone_number">
          <div class="heading"><label tabindex="0">Primary Contact Phone</label></div>
          <div class="page_content_block">
            <div tabindex="0">{{ club.primary_contact_phone_number }}</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import '../../../assets/module/css/course/courseAbout.min.css'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'club-detail',
    props: ['uuid', 'loadDataFromServer'],
    data: () => {
      return {
        tags: [],
        skills: [],
        userId: {}
      }
    },
    mounted () {
      this.loadDataForClubDetail()
    },
    methods: {
      ...mapActions([
        'loadClub',
        'loadLibrariesForUser'
      ]),
      showAll () {
        this.$root.$emit('bv::show::modal', 'clubDesc')
      },
      closeshowAll () {
        this.$root.$emit('bv::hide::modal', 'clubDesc')
      },
      goToEditPage () {
        this.$router.push({ name: 'editClub', params: { uuid: this.uuid } })
      },
      async loadDataForClubDetail () {
        await this.loadClub({ uuid: this.uuid, loadDataFromServer: this.loadDataFromServer })
        this.userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(this.userId)
        this.populateSkillsAndTags(this.club)
      },
      populateSkillsAndTags (entity) {
        let appliedTagMap = entity.appliedTagMap
        if (appliedTagMap) {
          let tagEntries = Object.entries(appliedTagMap)
          if (tagEntries && tagEntries.length > 0) {
            for (const [key, values] of tagEntries) {
              if (key) {
                values.forEach(value => {
                  this.tags.push(value)
                })
              }
            }
          }
        }
        let careerCompetenciesMap = entity.careerCompetenciesMap
        if (careerCompetenciesMap) {
          let skillEntries = Object.entries(careerCompetenciesMap)
          if (skillEntries && skillEntries.length > 0) {
            for (const [key, values] of skillEntries) {
              if (key) {
                values.forEach(value => {
                  this.skills.push(value)
                })
              }
            }
          } else {
            this.skills = entity.careerCompetenciesList
          }
        } else {
          this.skills = entity.careerCompetenciesList
        }
      }
    },
    computed: {
      ...mapState({
        'club': state => state.club.clubObject,
        'learningSpaces': state => state.assessment.learningSpaces,
        'ownerId': state => state.club.clubObject.ownerId,
        'owningLibraryId': state => state.club.clubObject.owningLibraryId
      }),
      'clubLibraryName': function () {
        let libName = ''
        let owningLibraryId = this.owningLibraryId
        this.learningSpaces.forEach(function (lib) {
          if (owningLibraryId === lib.uuid) {
            libName = lib.displayName
          }
        })
        return libName
      },
      'hasAtLeastOneLink': function () {
        if (!this.club.url && !this.club.twitter_url && !this.club.facebook_url) {
          return false
        }
        return true
      }
    }
  }
</script>

<style scoped>
.label {
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/app/club/components/ClubDetail.vue